import PageShell from "../components/PageShell";
import { viewsFor } from "../content/views";
import seoPages from "../content/seo-pages.json";

const views = viewsFor("home");
const seo = seoPages["/"];

export default function Home() {
  return (
    <PageShell
      title={seo.title}
      description={seo.description}
      bodyClass=""
      dataFrame={"on"}
      views={views}
    />
  );
}
